import script from "./Sam3Mixin.vue?vue&type=script&lang=js"
export * from "./Sam3Mixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__